import {observer} from 'mobx-react';
import {useNotificationSettingsListContext} from '../context/SettingsListContext';
import {ReactComponent as SettingsIcon} from '../assets/settings.svg';
import {ReactComponent as WarningIcon} from '../assets/warning.svg';
import theme from '../view/theme.module.scss';

export default observer(function SettingsHeader() {
    const {model} = useNotificationSettingsListContext();
    return <div className={theme.header}>
        <h1 className={theme.title}><SettingsIcon className={theme.titleIcon} aria-hidden="true"/>Notification Settings</h1>
        {!model.items.isLoading && model.maskItems.length > 0 && !model.phone && <div className={theme.warning} role="note">
            <WarningIcon aria-hidden="true"/><strong>WARNING!</strong>
            <div>Please add your phone number to enable text message notifications. <strong className={theme.profileLink}>Click here to update your profile.</strong></div>
        </div>}
    </div>;
});
